import type { FallbackProps } from 'react-error-boundary';
import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Button } from '@launchpad-ui/components';
/*
  * This is a custom error boundary fallback component that allows the user to reset the error boundary and try again.
  * It is intended to be used as a `FallbackComponent` in an `ErrorBoundary`.
  * @example
  * ```tsx
  * <ErrorBoundary severity="medium" FallbackComponent={RetryFallback}>
  *   <MyComponent />
  * </ErrorBoundary>
  * ```

 */
export const RetryFallback = ({ resetErrorBoundary }: FallbackProps) => (
  <div>
    <Message id="errors.retryFallback.body" />{' '}
    <Button size="small" onPress={() => resetErrorBoundary()}>
      {msg('errors.retryFallback.retry')}
    </Button>
  </div>
);
